import CrudReducer from './crudReducer';

const cr = new CrudReducer('todo_list');

const reducer = cr.Reducer;

export default reducer;
